import type { HintKey } from 'constants/hints';

export const VIEWED_HINT = 'Viewed Hint';
export type ViewedHintOptions = HintKey;

export const VIEWED_BANNER = 'Viewed Banner';
export type ViewedBannerOptions = 'InstallBanner' | 'InstallBannerDismissConfirm';

export const VIEWED_SUGGESTION_DROPDOWN = 'Viewed Dropdown';
export const TRAINED_MEMORY = 'Trained memories';
export const UPGRADE_OPPORTUNITY = 'Clicked Upgrade Opportunity CTA';
export const USER_DASHBOARD_FILTER_CHANGED = 'Applied User Dashboard List Filter';
export const TRIAL_STARTED = 'Started Trial [FE]';
export const SIGNED_UP = 'Signed Up [FE]';
export const TRIAL_STARTED_DATALAYER = 'Started Trial [DL]';
export const SIGNED_UP_DATALAYER = 'Signed Up [DL]';
export const SNOOZE_MEMORY_BANNER = 'Snooze Memory Banner';
export const SET_PREFERRED_PROJECTS_TAB = 'Set Preferred Projects Tab';
export const DOWNLOAD_MEMORY_TRACKER = 'Download Memory Tracker';
export const DOWNLOAD_MEMORY_HELP_CLICK = 'Memory Download Help Click';
export const CONNECTED_APP = 'Connect Your First App';
export const EXPORTED_REPORT = 'Exported report';
export const INITIATED_USER_ACTION = 'Initiated Action';
export const BATCH_CREATED_PLANNED_ENTRIES = 'Batch Created Planned Entries';
export const ADDED_MEMORY_TO_ENTRY = 'Memories Added to Time Entries';
export const VIEWED_TERMS = 'Viewed terms';

export enum DownloadMemorySource {
  Quest = 'Quest',
  Apps = 'Apps',
  WorkspaceMenu = 'WorkspaceMenu',
  Banner = 'Banner',
  Onboarding = 'Onboarding',
  EmptySidebar = 'EmptySidebar',
  TimesheetAssistant = 'TimesheetAssistant',
}
